<article class="org-logo-upload" [ngClass]="{'width-overlay': isRejected}">
  <core-layout-modal-feedback class="modal-feedback" *ngIf="isRejected" [type]="'fail'"
    [message]="'Error'"
    [text]="'Please upload a valid image file. Supported formats: PNG, JPEG, JPG, GIF.'"
    [buttonText]="'Ok'" (action)="dismissRejection()">
  </core-layout-modal-feedback>
  <div class="org-logo-upload-content">
    <span class="modal-close" (click)="onCancel()" title="Close">✕</span>
      <core-helpers-box-alert-message-icon
            [text]="'UPLOAD NEW LOGO'"
            [icon]="'warning'"
        ></core-helpers-box-alert-message-icon>
    <div>
      <p>You are about to upload a new logo for your organization. The new logo will be used across all email notifications.</p>
    </div>
      <core-storage-files-upload
        [multiple]="false" 
        [allowedTypes]="allowedImageTypes"
        [legacyTempId]="true" 
        (response)='upload($event)'
        (fileRejected)="onFileRejected($event)"
      ></core-storage-files-upload>
  </div>
  <fieldset>
    <core-helpers-forms-button-white [text]="'Next'" [disabled]="!ready" (click)="next()"></core-helpers-forms-button-white>
  </fieldset>
</article>
